const Jobs=[
    {
        id:1,
        Designation:"Software Interns",
        Email:"http://collabdots.com",
        description1:"PHP, Laravel ",
        description2:"JavaScript, Vue.js, React JS",
        description3:"HTML",
        description4:"CSS, Bootstrap"

    },
    {
        id:2,
        Designation:"AWS Cloud Architect",
        Email:"http://collabdots.com",
        description1:"Good knowledge on AWS ECS, AWS ECR, AWS EKS, AWS Fargate, Automation using AWS System Manager, AWS Lambda function, AWS Elastic Cache, AWS S3, AWS API Gateway, AWS CloudWatch and AWS SNS, AWS RDS and AWS DynamoDB.",
        description2:"Foundation knowledge on AWS DevOps Services and database (RDBMS & NoSql) solutions (runs on VM s).",
        description3:"Knowledge of kubernetes and Micro-services on AWS. AWS Solution Architect Certificate would be preferred.",
        description4:"Knowledge on Laravel and Vue JS would also be preferred."
    },


]

export default Jobs;